// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TEditSubscriptionRequest, TEditSubscriptionModel, IMappers, TEditSubscriptionResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IResponseSchema_edit_subscription } from '../../entities/entities/ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createEditSubscriptionModel(parameters: TEditSubscriptionRequest): TEditSubscriptionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'subscriptions',
    pathApi: '/v1/edit-subscription/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IEditSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TEditSubscriptionRequest;
}

export async function fetchEditSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IEditSubscriptionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TEditSubscriptionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createEditSubscriptionModel(parameters),
    config,
  )) as FetchResponse<TEditSubscriptionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IResponseSchema_edit_subscription, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TEditSubscriptionResponse>;
}
